import { render, staticRenderFns } from "./recipe-card.vue?vue&type=template&id=67d585cc&"
import script from "./recipe-card.vue?vue&type=script&lang=js&"
export * from "./recipe-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports